import { createContext } from 'react';
import { AnalysisSettingsContext } from '../../component/Settings/Settings.types';

export const analysisSettings = {} as AnalysisSettingsContext;

export const AnalysisContext = createContext(analysisSettings);